import React, { useEffect } from "react";
import { Flex, Box, Text, Heading } from "rebass";
import { buttonStyle, opacity, maxWidth, themeGet } from "styled-system";
import styled from "styled-components";
import { useFormState } from "react-use-form-state";

const NewsletterOverlay = ({ close }) => {
  const [formState, { label, checkbox, email, text }] = useFormState();

  const keyEvents = e => {
    if (e.keyCode === 27) {
      close();
    }
  };

  let strLocation;
  const strHeaderCopy = "[Sign up for news, stories, and events]";
  const strTerms =
    ",[You may unsubscribe at anytime. Zip code is used to improve the content we share. Refer to our Terms of Use for more information on how we store and protect your data.]";
  let str100Consent;
  let strStratCommConsent;

  useEffect(() => {
    strLocation = window.location;
    str100Consent =
      strHeaderCopy + ",[Centennial events and updates]" + strTerms;
    strStratCommConsent =
      strHeaderCopy + ",[UCLA news, stories, and events]" + strTerms;
  });

  useEffect(() => {
    document.addEventListener("keydown", keyEvents);
    return () => {
      document.removeEventListener("keydown", keyEvents);
    };
  }, []);

  // Copy text
  const title = "Sign up for news, stories and events";
  const preference = "Please Send Me";

  // Form field data
  const formInputs = [
    {
      id: "control_EMAIL",
      label: "Email",
      name: "Email",
      type: "email",
      pattern: "^[a-z0-9._%+-]+@[a-z0-9.-]+[.][a-z]{2,6}$",
      required: true
    },
    {
      id: "control_COLUMN1",
      label: "First Name",
      name: "First_Name",
      type: "text",
      required: true
    },
    {
      id: "control_COLUMN2",
      label: "Last Name",
      name: "Last_Name",
      type: "text",
      required: true
    },
    {
      id: "control_COLUMN3",
      label: "Zip Code",
      name: "Zip",
      type: "text",
      pattern: "^(?:[0-9]{5}(?:[-s -][0-9]{4})?|[0-9]{9})$",
      required: true
    },

    { name: "EA_100_CRM_Lead_Source", id: "control_COLUMN10", type: "hidden" },
    { name: "EA_100_Consent_Terms", id: "control_COLUMN6", type: "hidden" },
    {
      name: "StratComm_CRM_Lead_Source",
      id: "control_COLUMN4",
      type: "hidden"
    },
    { name: "StratComm_Consent_Terms", id: "control_COLUMN7", type: "hidden" }
  ];

  const formCheckboxes = [
    {
      id: "chckBox100",
      label: "Centennial events and updates",
      name: "SUBSCRIPTION_GROUP",
      value: "22833390"
    },
    {
      id: "chckBoxStratComm",
      label: "UCLA news, stories and events",
      name: "SUBSCRIPTION_GROUP",
      value: "22833381"
    }
  ];

  // Form field render functions
  const renderField = field => {
    let fieldType;
    switch (field.type) {
      case "hidden":
        return <input type="hidden" name={field.name} id={field.id} />;
      case "email":
        fieldType = email;
        break;
      default:
        fieldType = text;
    }

    return (
      <InputContainer mt={10} pt={3} pb={[1, 1, 2]}>
        <InputLabel
          as="label"
          {...label(field.name)}
          fontSize={1}
          fontFamily="medium"
          letterSpacing={0.12}
          opacity={formState.values[field.name] ? 1 : 0}
        >
          {field.label}
        </InputLabel>
        <Input
          as="input"
          id={field.id}
          {...fieldType({ name: field.name })}
          required={field.required}
          placeholder={field.label}
          pattern={field.pattern}
          maxLength={50}
          width={1}
          fontSize={[2, 2, 18]}
          lineHeight={1.66667}
          color="white"
        />
      </InputContainer>
    );
  };

  const renderCheckbox = cb => {
    return (
      <CheckboxLabel
        as="label"
        {...label(cb.name)}
        width={1}
        mt={15}
        fontSize={[1, 1, 2]}
        color="white"
      >
        <Checkbox
          as="input"
          id={cb.id}
          onClick={() => setTerms()}
          {...checkbox({ name: cb.name, value: cb.value })}
          mr={2}
        />
        {cb.label}
      </CheckboxLabel>
    );
  };

  const setTerms = () => {
    // Centennial
    if (document.getElementById("chckBox100").checked) {
      document.getElementById("control_COLUMN6").value = str100Consent;
      document.getElementById("control_COLUMN10").value = strLocation;
    } else {
      document.getElementById("control_COLUMN6").value = "";
      document.getElementById("control_COLUMN10").value = "";
    }

    // StratComm
    if (document.getElementById("chckBoxStratComm").checked) {
      document.getElementById("control_COLUMN7").value = strStratCommConsent;
      document.getElementById("control_COLUMN4").value = strLocation;
    } else {
      document.getElementById("control_COLUMN7").value = "";
      document.getElementById("control_COLUMN4").value = "";
    }
  };

  const onSubmitForm = e => {
    // Check if at least one field is checked
    const checkboxCheck =
      document.getElementById("chckBox100").checked ||
      document.getElementById("chckBoxStratComm").checked;

    if (!checkboxCheck) {
      alert("Please choose at least one of the categories to signup for!");
      e.preventDefault();
    }
  };

  return (
    <Overlay>
      <Inner justifyContent="center" alignItems="center" flexDirection="column">
        <CloseButton
          fontSize={1}
          fontFamily="medium"
          letterSpacing={0.12}
          onClick={() => {
            close();
          }}
        >
          Close
        </CloseButton>
        <Box py={[4, 4, 4, 6]} px={[3, 3, 3, 4]}>
          <FormContainer maxWidth={0} mx="auto">
            <Title
              as="h2"
              fontSize={[4, 4, 5]}
              fontFamily="semibold"
              letterSpacing={3}
              lineHeight={1}
              textAlign="center"
            >
              {title}
            </Title>
            <Box
              as="form"
              method="post"
              action="http://uclacrm.mkt5658.com/UCLAStrategicCommunications/UCLA-100-OptIn"
              pageId="22967225"
              siteId="566158"
              parentPageId="22967223"
              id="formOverlay"
              target="_blank"
              onSubmit={e => {
                onSubmitForm(e);
              }}
              width={[1, 1 / 2]}
              mx="auto"
              mt={[2, 2, 0]}
            >
              {formInputs.map((field, i) => {
                return <div key={i}>{renderField(field)}</div>;
              })}
              <Text
                width={1}
                mt={4}
                fontSize={1}
                fontFamily="medium"
                letterSpacing={0.12}
              >
                {preference}
              </Text>
              <div id="container_SUBSCRIPTION_GROUP">
                {formCheckboxes.map((cb, i) => {
                  return <div key={i}>{renderCheckbox(cb)}</div>;
                })}
              </div>
              <input type="hidden" name="formSourceName" value="StandardForm" />
              {/* DO NOT REMOVE HIDDEN FIELD sp_exp */}
              <input type="hidden" name="sp_exp" value="yes" />
              <Flex>
                <SubmitButton
                  as="button"
                  type="submit"
                  variant="yellow"
                  mt={4}
                  py={3}
                  px={5}
                  fontSize={1}
                  fontFamily="medium"
                  letterSpacing={0.12}
                  textAlign="center"
                >
                  Sign Up
                </SubmitButton>
              </Flex>
              <Text
                width={1}
                mt={3}
                fontSize={1}
                fontFamily="medium"
                letterSpacing={0.12}
              >
                You may unsubscribe at anytime. Zip code is used to improve the
                content we share. Refer to our{" "}
                <a href="http://www.ucla.edu/terms-of-use/" target="_blank">
                  Terms of Use
                </a>{" "}
                for more information on how we store and protect your data.
              </Text>
            </Box>
          </FormContainer>
        </Box>
      </Inner>
    </Overlay>
  );
};

const Overlay = styled(Box)`
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  max-height: 100vh;
  overflow-y: auto;
  /* #2774AE with 98% opacity */
  background: rgba(39, 116, 174, 0.98);
`;

const Inner = styled(Flex)`
  min-height: 100vh;
  position: relative;
  @media screen and (max-height: 676px) {
    padding-top: ${themeGet("space.4")}px;
  }
`;

const CloseButton = styled(Text)`
  position: absolute;
  top: ${themeGet("space.4")}px;
  right: ${themeGet("space.4")}px;
  text-decoration: underline;
  cursor: pointer;
`;

const FormContainer = styled(Text)`
  ${maxWidth}

  a {
    text-decoration: underline;
  }
`;

const Title = styled(Heading)`
  text-transform: uppercase;
`;

const InputContainer = styled(Text)`
  position: relative;
  border-bottom: 1px solid currentColor;
`;

const InputLabel = styled(Text)`
  ${opacity}
  position: absolute;
  top: 0;
  left: 0;
  transition: opacity 0.2s ease, color 0.2s ease;
`;

const Input = styled(Text)`
  background: none;
  border: none;
  border-radius: 0;

  &::placeholder {
    color: inherit;
    opacity: 0.7;
  }
`;

const CheckboxLabel = styled(Text)`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const Checkbox = styled(Text)`
  position: relative;

  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    height: 15px;
    width: 15px;
    border: 2px ${themeGet("colors.white")} solid;
    background-color: ${themeGet("colors.blue.1")};
    transition: background-color 0.2s ease;
  }

  &:checked:after {
    background-color: ${themeGet("colors.white")};
  }
`;

const SubmitButton = styled(Text)`
  ${buttonStyle};
  border: none;
  cursor: pointer;
`;

export { NewsletterOverlay };
